/*
 * 세이프가드 홈페이지(safeguard.finbridge.co.kr)
 * LGU+ 요청에 따라 핀브릿지 홈페이지와 별도 URL 로 세이프가드·금융사기방지 소개 페이지를 첫 화면으로 보여주고,
 * 상단 메뉴는 고객문의·해지하기·환불하기만 노출한다. 같은 앱을 도메인으로 구분해 서비스한다.
 * 상단 메뉴는 핀브릿지 홈페이지(VUE_APP_FB_HOMEPAGE_URL)의 해당 화면을 새 창으로 연다.
 * 세이프가드 도메인 목록은 환경별 VUE_APP_SAFEGUARD_HOSTS(쉼표 구분)로 관리한다.
 */
const SAFEGUARD_HOSTS = (process.env.VUE_APP_SAFEGUARD_HOSTS || "")
  .split(",")
  .map((host) => host.trim())
  .filter(Boolean);

export const isSafeguardHost = () => SAFEGUARD_HOSTS.includes(window.location.hostname);

export const SAFEGUARD_SITE_TITLE = "세이프가드·금융사기방지";

export const FB_HOMEPAGE_URL = process.env.VUE_APP_FB_HOMEPAGE_URL;

export const safeguardMenus = [
  {
    title: "고객문의",
    pathName: "Support"
  },
  {
    title: "해지하기",
    pathName: "PassSafeguardTermination"
  },
  {
    title: "환불하기",
    pathName: "Refund"
  }
];
